import React from 'react';
import { store } from '../../store'
import { Link } from 'react-router-dom'
const Menu = ({onClickInside, onClickOutside, onRouteChange, isDashboard, isSettings, onOpen}) => {
const signOut = () => {
localStorage.clear()
window.location = '/'
}
	if(store.getState().user.isSignedIn)
	return (<div
			onMouseOver={onClickInside.bind()}
         	onMouseOut={onClickOutside.bind()}>
			<div className="menu">
			<span className="menu_outer">@<b>{store.getState().user.user.username}</b></span>
			{(!isDashboard && !isSettings && store.getState().website.url !== undefined)
			? <a className="menu_item" rel="noopener noreferrer" target="_blank" href={`${process.env.REACT_APP_API}/${store.getState().website.url}`}>View Page</a>
			: null
				}
			{!isDashboard
			?	<Link className="menu_item" onClick={
				(route) => {
					onOpen('')
					onRouteChange('dashboard')
				}} to={'/dashboard'}>Dashboard</Link>
			: null
				}
			<span className="menu_item" onClick={signOut.bind()}>Signout</span>
			</div></div>)
	else
	return (<div
			onMouseOver={onClickInside.bind()}
         	onMouseOut={onClickOutside.bind()}>
			<div className="menu menu_home">
			<Link className="menu_item home_item" to={'/signin'} onClick={
				(route) => {
					onOpen('') }}>Signin</Link>
			<Link className="menu_item home_item" to={'/create'} onClick={
				(route) => {
					onOpen('') }}>Create Profile</Link>
			</div></div>)
}
export default Menu